

import { faChevronDown, faChevronRight, faMinus, faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import '../../CSS/style.css';

export default function Section6() {

    const faq = [
        {
            question: " What is Stabilix?",
            answer: "Stabilix is a decentralized platform built on the Avalanche Subnet, enabling seamless, secure, and scalable stablecoin transfers with unique features like USDT-based gas fees and cross-chain compatibility.",
        },
        {
            question: " How do I get started with Stabilix?",
            answer:
                "Simply connect your wallet, configure the Avalanche Subnet, and deposit stablecoins like USDT or USDC. Our intuitive interface makes it easy to begin transferring.",
        },
        {
            question: "What stablecoins does Stabilix support?",
            answer:
                "Stabilix supports major stablecoins, including USDT, USDC, and BUSD, with plans for further expansion.",
        },
        {
            question: "How are gas fees handled on Stabilix?",
            answer:
                'Gas fees are paid directly in USDT, eliminating the need for holding native tokens, thanks to our innovative gas station mechanism.',
        },
        {
            question: "Is Stabilix secure?",
            answer:
                "Yes, Stabilix employs smart contracts that undergo rigorous security audits. Additionally, optional KYC/AML layers ensure compliance and enhanced protection.",
        },
        {
            question: " Can I use Stabilix across multiple blockchains?",
            answer: 'Yes, Stabilix supports cross-chain interoperability, enabling seamless transfers between different blockchain networks.',

        },
        {
            question: " What are the transaction speeds on Stabilix?",
            answer: ' Transactions are processed with near-instant finality, leveraging the high-speed infrastructure of the Avalanche Subnet.',

        }
    ];

    const [expandedIndex, setExpandedIndex] = useState(0);

    const toggleExpand = (index) => {
        if (expandedIndex === index) {
            setExpandedIndex(-1); // Collapse if already expanded
        } else {
            setExpandedIndex(index); // Expand the selected item
        }
    };


    return (
        <div>
        <div className=' min-h-screen py-10 lg:py-0 flex items-center font-Montserrat bg-black text-white overflow-hidden'>
            <div className='flex flex-col lg:flex-row gap-10 w-[90%] mx-auto relative '>
                <div className='w-[100%] lg:w-[50%]'>
                    <div className='flex justify-start'>
                        <h1 className='font-bold text-4xl gradient-text '>Frequently Asked <br /> Questions</h1>
                    </div>
                    <p className='text-[#E1E1E1] mt-5 leading-10'> Here you'll find answers to common questions about our platform, how it works, including token purchases, vesting and the rewards processes.</p>
                </div>
                <div className='w-[100%] lg:w-[50%] '>
                    <div className='z-10 relative'>
                        {faq.slice(0, 6).map((data, index) => (
                            <div
                                key={index}
                                onClick={() => toggleExpand(index)}
                                className={` border border-[#E1E1E133] bg-[#60698133] rounded-md cursor-pointer mt-2 duration-500 transform transition ease-in-out ${expandedIndex === index ? "h-full" : "h-full"
                                    }`}
                            >
                                <div className="flex ">
                                    <div className="w-[10%] flex items-center justify-center">
                                        <button className="font-bold">
                                            <FontAwesomeIcon icon={expandedIndex === index ? faMinus : faPlus} className={`text-white duration-500 ${expandedIndex === index ? 'rotate-180' : ''}`} />
                                        </button>
                                    </div>
                                    <div className="w-[90%] px-3 py-1">
                                        <h1 className="font-semibold text-lg py-2">{data.question}</h1>
                                    </div>
                                </div>
                                <div
                                    className={`duration-300 px-5 ease-in-out rounded-b-md overflow-hidden ${expandedIndex === index
                                        ? "max-h-[250px]  md:max-h-[140px] pb-3"
                                        : "max-h-0"
                                        }`}
                                >
                                    <p
                                        dangerouslySetInnerHTML={{ __html: data.answer }}
                                        className="text-white/70 font-medium duration-500"
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className='absolute top-1/2 -translate-y-1/2 bg-gradient-to-b from-[#856E4F]/20 to-[#F6FFE9]/20 rounded-full blur-3xl h-[80vh] w-[60%] -translate-x-[15%] z-0'></div>
                </div>
            </div>
        </div>
        </div>
    )
}
